/**
 * Configuración de citas desde TPSC_PARAMETROS_GENERALES.
 * 
 * Legacy: GeneralParameters, Constants.java
 * - CITA_MINIMA_DURACION (default: 0)
 * - CITA_MAXIMA_DURACION (default: 24)
 * - HOLIDAYS (lista separada por comas)
 * - LIMIT_DAYS_PROGRAM (default: 5)
 */
export interface ConfiguracionCita {
    /** Duración mínima de cita en horas (default: 0) */
    minDuracionHoras: number;
    
    /** Duración máxima de cita en horas (default: 24) */
    maxDuracionHoras: number;
    
    /** Lista de fechas festivas (formato ISO: YYYY-MM-DD) para bloquear en calendarios */
    festivos: string[];
    
    /**
     * Límite de días hábiles para considerar una cita como tardía.
     * Si se supera este valor, se requiere justificación al crear la cita.
     * Legacy: GeneralParameters.LIMIT_DAYS_PROGRAM (default: 5)
     */
    limiteDiasProgramacion: number;
    
    /**
     * Opciones de periodicidad dinámicas desde TPSC_PARAMETROS_GENERALES.
     * Legacy: Utilidades.getOptionsList(Constants.LIST_TYPE_PERIODICITY)
     * Cada entry: {value: "D", label: "Diario"}
     */
    periodicidades?: { value: string; label: string }[];
}

/**
 * Valores por defecto de configuración (legacy: Constants.java).
 * DEFAULT_VALUES_MIN_APPOINTMEN_DURATION_LIMIT = 0
 * DEFAULT_VALUES_MAX_APPOINTMEN_DURATION_LIMIT = 24
 */
export const DEFAULT_CONFIGURACION_CITA: ConfiguracionCita = {
    minDuracionHoras: 0,
    maxDuracionHoras: 24,
    festivos: [],
    limiteDiasProgramacion: 5,
    periodicidades: []
};

/**
 * Convierte un array de strings ISO a objetos Date en hora LOCAL.
 * Útil para el [disabledDates] de p-calendar.
 * 
 * IMPORTANTE: new Date("2025-08-01") interpreta como UTC, causando
 * problemas de timezone. Usamos split para crear fecha local.
 */
export function convertirFestivosADates(festivos: string[]): Date[] {
    if (!festivos || festivos.length === 0) {
        return [];
    }
    return festivos
        .map(f => {
            // Parsear como fecha LOCAL (no UTC) para evitar problemas de timezone
            // "2025-08-01" -> new Date(2025, 7, 1) (mes 0-indexed)
            const parts = f.split('-');
            if (parts.length === 3) {
                return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
            }
            return new Date(f);
        })
        .filter(d => !isNaN(d.getTime()));
}
